module.exports = "/assets/5c80dbc11b4eb124a9815870695d95e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/G3.png
// module id = 2516
// module chunks = 0